import styled from "@emotion/styled"
import { Box } from "@chakra-ui/react"

export const StyledIcon = styled(Box)`
  .icon {
    width: ${(props) => (props.width ? `${props.width}` : "16px")};
    height: ${(props) => (props.height ? `${props.height}` : "16px")};
  }
`
